export default __webpack_public_path__ + "static/media/Bellevi.d5b24c59.png";